// Bootstrap pattern for async module loading in MFE
import("./index");
export {};
